import api from "../../providers/api";
import history from "../../providers/history";
import { GetObject } from "../../providers/storage";
import { IAuthenticatedUser } from "../authentication/types";
import { IItemObservationFilter, IItemObservationSaveRequestPayload } from "./types";

export const itemsObservationsListRequestService = (filter?: IItemObservationFilter) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');
    
    let stringFilter = new URLSearchParams({
        observation: filter?.observation || '',
        page: String(filter?.page || 1),
        perPage: String(filter?.perPage || 10)
    }).toString();

    return api.get(`settings/text-models/item-observation/?${stringFilter}`, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
}

export const itemsObservationsSaveRequestService = (itemObservation: IItemObservationSaveRequestPayload, id?:string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    if (id) {
        return api.put(`settings/text-models/item-observation/${id}`, itemObservation, {
            headers: {
                Authorization: `Bearer ${authenticatedUser.token}`
            }
        })
    }

    return api.post('settings/text-models/item-observation', itemObservation, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
}

export const itemsObservationsRemoveRequestService = ( itemObservationId: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');
    
    return api.delete(`settings/text-models/item-observation/${itemObservationId}`, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
}